import { SET_PERMISSIONS, CLEAR_PERMISSIONS } from "../types/permissions.types";

export const setPermissions = (menus) => ({
  type: SET_PERMISSIONS,
  payload: menus
});

export const clearPermissions = () => ({
  type: CLEAR_PERMISSIONS
});
